import { css } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
} from '../../styles/variables.style';

import iconone from '../../assets/images/img-3928.jpeg';
import icontwo from '../../assets/images/img-3827.jpeg';
import selectArrow from '../../assets/images/select-arrow.png';

export const challangeContainer = css`
  width: 100%;
  max-width: 1280px;
  margin: auto;
  padding: 0 15px;
  position: relative;
  @media(max-width:767px){
    padding:0;
  }
  &:before {
    @media (min-width: ${breakpoints.lg.up}) {
      content: '';
      width: 100%;
      background: url(${iconone}) no-repeat 18% -22px,
        url(${icontwo}) no-repeat 83% 65%;
      padding: 50px 20px;
      position: absolute;
      top: -120px;
      height: 160px;
      z-index: -1;
    }
  }
  .newCard-add{
    .card-body{
      h4{
        max-width:140px !important;
        font-family: 'Poppins', sans-serif !important;
      }
    }
  }
  .col-md-4{
    -webkit-box-flex: 0;
    -ms-flex: 0 0 33.333333%;
    -webkit-flex: 0 0 33.333333%;
    -ms-flex: 0 0 33.333333%;
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    padding: 10px 30px;
    @media (max-width: 992px) {
      padding: 10px 10px;
      @media (max-width: 767px) {
        -webkit-box-flex: 0;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
        padding: 0 20px;
        margin-bottom: 20px;
      }
    }
    &:nth-child(01) {
      .newCard-add {
        border-color: #edc224;
        .card-body {
          h4 {
            color: ${appColors.white} !important;
          }
        }
      }
      .card-body {
        h4 {
          color: #edc224;
        }
      }
    }
    &:nth-child(03) {
      .card {
        border-color: #edc224;
        .card-body {
          h4 {
            color: #edc224;
          }
          .editevenbutton {
            background: #edc224;
          }
        }
      }
    }
    &:nth-child(04) {
      .card {
        border-color: #72ff6b;
        .card-body {
          h4 {
            color: #72ff6b;
          }
          .editevenbutton {
            background: #72ff6b;
          }
        }
      }
    }
    &:nth-child(05) {
      .card {
        border-color: #2b3cdd;
        .card-body {
          h4 {
            color: #2b3cdd;
          }
          .editevenbutton {
            background: #2b3cdd;
          }
        }
      }
    }
  }
  .card{
    width: 100%;
    box-shadow: none;
    border: 2px solid #de7028;
    border-radius: 8px;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
    padding: 15px;
    height: auto;
    min-height: 420px;
    @media (max-width: 992px) {
      margin-bottom: 0;
      min-height:auto;
    }
    &:hover {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.28) !important;
      transition: all 0.5s;
    }
    .overflow {
      img {
        width: 100%;
        border-radius: 8px;
        object-fit: cover;
        &:hover {
          transform: scale(1);
        }
      }
      .card-body {
        width: 100%;
        max-width: 190px;
        margin: auto;
        h4 {
          padding: 0;
          margin: 10px 0;
          text-align: center;
          color: #dd6e2b;
          font-size: 18px;
          font-family: Fredoka one, sans-serif;
          font-weight: 400;
        }
        .editevenbutton {
          padding: 13px 0;
          background: #dd6e2b;
          border-radius: 8px;
          text-transform: uppercase;
          &:hover {
            background: #edc224;
            transition: all 0.5s;
          }
        }
      }
  }
`;

export const batchBanner = css`
  display: block;
  width: 100%;
  position: relative;
  padding: 0px 40px;
  @media (max-width: 767px) {
    padding: 0 20px;
  }
  h2 {
    position: absolute;
    top: 7%;
    left: 50%;
    -webkit-transform: translate(-50%);
    -moz-transform: translate(-50%);
    -ms-transform: translate(-50%);
    transform: translate(-50%);
    font-size: 41px;
    color: #fff;
    font-family: Fredoka one, sans-serif;
    font-weight: 400;
    @media (max-width: 767px) {
      font-size: 24px;
    }
  }
  img {
    width: 100%;
    border-radius: 8px;
    @media (max-width: 767px) {
      height: 140px;
      object-fit: cover;
      border-radius: 8px;
    }
  }
  span {
    width: 100%;
    max-width: 330px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 767px) {
      text-align: center;
      transform: translate(-50%, -60%);
      top: 60%;
    }
    img {
      width: 100%;
      max-width: 330px;
      @media (max-width: 767px) {
        max-width: 150px;
        height: auto;
      }
    }
  }
`;



export const batchTitle = css`
  text-align: center;
  // border:2px solid red;
  padding: 10px 0;
  font-size: 36px;
  font-weight: 500;
  position: relative;
  font-family: Fredoka one, sans-serif;
  @media (max-width: 767px) {
    padding: 30px 0;
    font-size: 28px;
  }
  &:after {
    content: '';
    width: 65px;
    height: 4px;
    background: #edc224;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%);
    @media (max-width: 767px) {
      bottom: 18px;
    }
  }
`;

export const editBtn = css`
  background: transparent;
  width: 25px;
  padding: 0;
  float: right;
  margin-bottom: 8px;
  &:hover {
    background: transparent;
  }
  img {
    width: 30px;
  }
`;

export const plusDelete = css`
  display: inline-flex;
  float: left;
  button {
    display: inline-block;
    width: 25px;
    height: 25px;
    font-size: 8px;
    border-radius: 50%;
    margin: 0 3px;
  }
`;

export const editBatchesMain = css`
  width: 100%;
  max-width: 560px;
  margin: auto;
  padding: 40px 0;
  padding-bottom: 10px;
  position: relative;
  @media (max-width: 992px) {
    margin-top: 50px;
    @media (max-width: 767px) {
      margin-top: -20px;
      padding: 40px 15px 15px;
    }
  }
  h3 {
    text-align: center;
    font-family: Fredoka one, sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #000;
  }
  .add-item-box {
    display: block;
    margin-bottom: 20px;
    position: relative;

    .custom-dropdown {
      min-width: inherit;
    }
    .item-list {
      display: flex;
      align-items: center;
      margin-top: 10px;
      margin-left: -5px;
      margin-right: -5px;
      .item-container {
        padding: 5px;
        .item-name {
          font-size: 13px;
          font-weight: 400;
          background-color: ${appColors.orange};
          padding: 2px 6px 2px 2px;
          color: ${appColors.white};
          border-radius: 4px;
        }
        .closeBtn {
          color: ${appColors.orange};
          display: inline-block;
          width: 16px;
          height: 16px;
          text-align: center;
          border-radius: 4px;
          font-size: 10px;
          line-height: 17px;
          background-color: ${appColors.white};
          margin-right: 4px;
        }
      }
    }
    .custom-dropdown {
      width: 100%;
      &:before {
        display: none;
      }
      &:after {
        display: none;
      }
    }
    label {
      display: block;
      width: 100%;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 600;
      @media (max-width: 767px) {
        font-size: 14px;
      }
    }
    input {
      width: 100%;
      height: 50px;
      border: 1px solid ${appColors.gray800};
      border-radius: 5px;
      color: #636363;
      font-weight: normal;
      padding: 0 20px;
    }
    select {
      width: 100%;
      height: 50px;
      border: 1px solid ${appColors.gray800};
      border-radius: 5px;
      color: #636363;
      font-weight: normal;
      background: ${appColors.white};
      outline: none;
      -moz-appearance: none; /* Firefox */
      -webkit-appearance: none; /* Safari and Chrome */
      appearance: none;
      background-image: url(${selectArrow});
      background-repeat: no-repeat;
      background-size: 16px;
      background-position: 97%;
    }
  }
`;

export const editBatchIcon = css`
  width: auto;
  height: auto;
  background: ${appColors.white};
  border-radius: 50%;
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    position: inherit;
    transform: inherit;
    margin: auto;
    top: inherit;
    left: inherit;
    width: auto;
    height: auto;
  }
  img {
    padding: 15px;
    width: 75px;
  }
`;

export const editBtnFlex = css`
  display: flex;
  justify-content: center;
  .popupbutton2 {
    min-width: inherit;
    width: 100%;
    max-width: 170px;
    text-align: center;
    padding: 12px 12px;
    margin: 5px 8px;
    text-transform: uppercase;
    font-size: 14px;
    background: #dd6e2b;
    border-radius: 7px;
    &:nth-child(01) {
      background: #edc224;
    }
    &:hover {
      background: ${appColors.gray500};
    }
  }
`;

export const dFlex = css`
  display: flex;
  .add-item-box {
    width: 100%;
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const createChallengeCols = css``;
export const createChallengeMain = css`
  width: 100%;
  max-width: 620px;
  background: #fff;
  margin: auto;
  border-radius: 5px;
  position: relative;
  padding: 25px;
  @media (max-width: 767px) {
    padding: 15px;
    margin: 0 15px;
  }
  .closeBtn {
    position: absolute;
    right: 8px;
    top: 6px;
    font-size: 19px;
    font-weight: 300;
    cursor: pointer;
  }
  td {
    input[type='checkbox'] {
      margin-top: 0;
      height: 15px;
      width: 15px;
      position: relative;
      top: 2px;
    }
  }
  h3 {
    text-align: center;
    font-family: Fredoka one, sans-serif;
    font-weight: 500;
    font-size: 22px;
    color: #000;
  }
  input[type='text'] {
    width: 100%;
    height: 50px;
    border: 1px solid #323232;
    border-radius: 5px;
    color: #636363;
    font-weight: normal;
    margin: 12px 0;
  }
  .custom-dropdown {
    min-width: inherit;
    width: 100%;
    margin: 12px 0;
    &:before {
      display: none;
    }
    &:after {
      display: none;
    }
    select {
      width: 100%;
      height: 50px;
      border: 1px solid #323232;
      border-radius: 5px;
      color: #636363;
      font-weight: normal;
      background: #fff;
      outline: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      appearance: none;
      background-image: url(${selectArrow});
      background-repeat: no-repeat;
      -webkit-background-size: 16px;
      background-size: 16px;
      -webkit-background-position: 97%;
      background-position: 97%;
    }
  }
`;


export const formFlex = css`
  display: flex;
  width: 100%;
  .add-item-box {
    width: 100%;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const subTitle = css`
  text-align: center;
  margin: 40px auto;
  font-size: 30px;
  font-family: ${fontFamily.fredoka};
`;

export const welcomecenter = css`
// position: "relative",
//   display: flex;
//   border: 2px solid red;
//   justify-content: center;
//   align-items: flex-start;
`;
